import { isNil } from 'es-toolkit/compat';
import { WeatherStationLatestObservationValues } from '../../weatherStations.types';

export type ServerObservationValues = {
  airTemp?: number;
  dewPointTemperature?: number;
  precipitation_1hr?: number;
  relativeHumidity?: number;
  windDirection?: number;
  windGust?: number;
  windSpeed?: number;
};

export const getReverseDirection = (degrees: number): number => {
  const reverseDegrees = (degrees + 180) % 360;
  return reverseDegrees < 0 ? reverseDegrees + 360 : reverseDegrees;
};

export const transformObservationValues = (
  values: ServerObservationValues,
): WeatherStationLatestObservationValues => {
  const { precipitation_1hr: precipitation1Hr, ...restValues } = values;

  const windDirectionToward = !isNil(values.windDirection)
    ? getReverseDirection(values.windDirection)
    : undefined;

  return {
    ...restValues,
    precipitation1Hr,
    windDirectionToward,
  };
};
